import styled from 'styled-components'
import { Box } from '../../UI/Box'

// inheriting box might seem GoHorse but we keep useful props so yeah, it's fine (is it?)
export const Grid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  @media screen and (min-width: 2000px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr; // edge case for huge displays
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.expanded}px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.medium}px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.compact}px) {
    grid-template-columns: 1fr;
  }
`
